import Lottie from "lottie-react"
import animationData from "../public/assets/lottie/loader.json"

interface LoaderProps {
  className?: string
  size?: number
}

const Loader = ({ className = "", size = 50 }: LoaderProps) => {
  return (
    <div className={`lottie ${className}`}>
      <Lottie animationData={animationData} loop={true} style={{ width: size, height: size }} />
    </div>
  )
}

export default Loader
